<template>
    <base-section v-if="section" :section="section" :show-config-ui="showConfigUi" @edit-section="$emit('edit-section')"
                  @delete-section="$emit('delete-section')">
        <template #toolbar>
            <el-link @click="showMore" icon="el-icon-more" :underline="false"></el-link>
        </template>
        <div v-if="sectionConfig && sectionConfig.tabs">
            <el-tabs v-if="sectionConfig.tabs.length>1" v-model="currentTabName" @tab-click="onTabClick" class="yq-tabs">
                <el-tab-pane v-for="tab in sectionConfig.tabs" :key="tab.name" :label="tab.name" :name="tab.name">
                    <news-list v-if="data&&!currentViewStyle" :data="data.content" :datasource="currentDatasource" view-name="index"
                               @show-details="showDetails"></news-list>
                    <component v-if="data&&currentViewStyle" :is="currentViewStyle.template.component" :data="data.content"
                               :config="currentViewStyle.config" @show-details="showDetails"
                               :datasource="currentDatasource"></component>
                </el-tab-pane>
            </el-tabs>
            <div v-else>
                <news-list v-if="data&&!currentViewStyle" :data="data.content" :datasource="currentDatasource" view-name="index"
                           @show-details="showDetails"></news-list>
                <component v-if="data&&currentViewStyle" :is="currentViewStyle.template.component" :data="data.content"
                           :config="currentViewStyle.config" @show-details="showDetails" :page-number="1" :page-size="10"
                           :datasource="currentDatasource"></component>
            </div>
        </div>
    </base-section>
</template>

<script>
    import BaseSection from './BaseSection'
    import sectionService from '../../service/section'
    import newsSectionService from '../../service/news-section'
    import datasourceConfigService from '../../service/datasource-config'
    import NewsList from '../../components/common/NewsList'
    import viewStyleService from '../../service/view-style'
    import templates from '../../components/templates'

    export default {
        name: "NewsSection",
        components: {BaseSection, NewsList},
        props: {
            id: Number,
            showConfigUi: Boolean,
            refreshId: {
                type: Number,
                default: 0
            },
            pageId: Number,
            templateId: Number,
            timeInterval: String
        },
        data() {
            return {
                section: null,
                sectionConfig: null,
                currentTabName: null,
                currentTab: null,
                currentDatasource: null,
                currentViewStyle: null,
                data: null,
            }
        },
        watch: {
            id(){
                this.init()
            },
            pageId(){
                this.init()
            },
            templateId(){
              this.init()
            },
            refreshId() {
                this.init()
            },
            timeInterval() {
                this.init()
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                const response = await sectionService.getSection(this.id, {templateId: this.templateId})
                this.section = response.data
                if (this.section.config) {
                    this.sectionConfig = JSON.parse(this.section.config)
                    if (this.sectionConfig.tabs && this.sectionConfig.tabs.length > 0) {
                        this.currentTabName = this.sectionConfig.tabs[0].name
                        await this.loadCurrentTab()
                    }
                }
            },
            onTabClick(){
                this.loadCurrentTab()
            },
            async loadCurrentTab(){
                this.data = null
                this.currentTab = this.sectionConfig.tabs.find(item => item.name === this.currentTabName)
                const datasource = (await datasourceConfigService.getDatasourceConfig(this.currentTab.datasource.id)).data
                datasource.fields = JSON.parse(datasource.fields)
                this.currentDatasource = datasource
                if(this.currentTab.indexStyle){
                    const viewStyle = (await viewStyleService.getViewStyle(this.currentTab.indexStyle.id)).data
                    viewStyle.template = templates.find(item=>item.id===viewStyle.componentId)
                    this.currentViewStyle = viewStyle
                }else{
                    this.currentViewStyle = null
                }
                const dataResponse = await newsSectionService.search({
                    pageId: this.pageId,
                    templateId: this.templateId,
                    sectionId: this.id,
                    tabName: this.currentTab.name,
                    timeField: this.currentTab.timeField,
                    timeInterval: this.timeInterval,
                    viewName: 'index',
                    fields: this.currentViewStyle ? this.currentViewStyle.template.getFields(this.currentViewStyle.config):null,
                    page: 0,
                    size: 10,
                    sort: newsSectionService.parseSortExpr(this.currentTab.sort)
                })
                this.data = dataResponse.data
            },
            showMore() {
                const url = [document.location.origin, document.location.pathname,
                    '#/main/news-section/more?sectionId=', this.id, '&pageId=', this.pageId || '',
                    '&templateId=', this.templateId || '', '&tabName=', encodeURIComponent(this.currentTab.name),
                    '&timeInterval=', encodeURIComponent(this.timeInterval||'')
                ]
                window.open(url.join(''), '_blank')
            },
            showDetails(id) {
                const url = [document.location.origin, document.location.pathname,
                    '#/main/news-section/details?sectionId=', this.id, '&pageId=', this.pageId || '',
                    '&templateId=', this.templateId || '', '&tabName=', encodeURIComponent(this.currentTab.name),
                    "&id=", encodeURIComponent(id)
                ]
                window.open(url.join(''), '_blank')
            }
        }
    }
</script>

<style scoped>

</style>
